import { useRef } from "react";
import { icon } from "../functions/icons";

export function PdfFileInput({ onFileSelect, value = [] }) {
  const fileInputRef = useRef();

  function handleChange(event) {
    const files = Array.from(event.target.files).filter(
      (file) => file.type === "application/pdf"
    );

    const existingNames = new Set(value.map((f) => f.name));
    const newUniqueFiles = files.filter((f) => !existingNames.has(f.name));

    onFileSelect([...value, ...newUniqueFiles]);
  }

  function removeFile(fileName) {
    const filtered = value.filter((file) => file.name !== fileName);
    onFileSelect(filtered);
  }

  return (
    <>
      <input
        type="file"
        accept=".pdf"
        multiple
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleChange}
      />
      <div
        className="file-upload-area"
        onClick={() => fileInputRef.current.click()}
      >
        {value.length > 0 ? (
          <div className="small-text">
            {value.map((file, index) => (
              <div key={index} className="pdf-content" >
                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {file.name}
                </span>
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFile(file.name);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "var(--error-600)",
                    fontSize: "1rem",
                    cursor: "pointer",
                    marginLeft: "0.5rem",
                    display: "flex",
                  }}
                  aria-label={`Verwijder ${file.name}`}
                >
                {icon("trash")}
                </button>
              </div>
            ))}
          </div>
        ) : ( <p
          className="small-text standard-small-margin-top"
          style={{ color: "var(--grey-700)", marginBottom: "0.5rem" }}
        >
          Klik hier om .pdf bestanden te uploaden.
        </p>)}
      </div>
    </>
  );
}
